import { defineMessages } from '@/components/formatted_message/FormattedMessage';
import { APP_DICTIONARY } from './root';

export const TRANSLATED_ACTIONS = defineMessages({
  activate: { id: 'app.common.actions.activate' },
  add: { id: 'app.common.actions.add' },
  addAll: { id: 'app.common.actions.addAll' },
  archive: { id: 'app.common.actions.archive' },
  back: { id: 'app.common.actions.back' },
  cancel: { id: 'app.common.actions.cancel' },
  chooseRecipients: { id: 'app.common.actions.chooseRecipients' },
  clearFilterLong: { id: 'app.common.actions.clearFilterLong' },
  close: { id: 'app.common.actions.close' },
  change: { id: 'app.common.actions.change' },
  changeStatus: { id: 'app.common.actions.changeStatus' },
  changeSupplier: { id: 'app.common.actions.changeSupplier' },
  keep: { id: 'app.common.actions.keep' },
  understand: { id: 'app.common.actions.understand' },
  confirm: { id: 'app.common.actions.confirm' },
  continue: { id: 'app.common.actions.continue' },
  copy: { id: 'app.common.actions.copy' },
  delete: { id: 'app.common.actions.delete' },
  detail: APP_DICTIONARY.detail,
  download: { id: 'app.common.actions.download' },
  edit: { id: 'app.common.actions.edit' },
  exitFullScreen: { id: 'app.common.actions.exitFullScreen' },
  export: { id: 'app.common.actions.export' },
  exportChart: { id: 'app.common.actions.exportChart' },
  exportTable: { id: 'app.common.actions.exportTable' },
  finish: { id: 'app.common.actions.finish' },
  fullScreen: { id: 'app.common.actions.fullScreen' },
  import: { id: 'app.common.actions.import' },
  move: { id: 'app.common.actions.move' },
  next: { id: 'app.common.actions.next' },
  no: { id: 'app.common.actions.no' },
  overLayedZoom: { id: 'app.common.actions.overLayedZoom' },
  preview: { id: 'app.common.actions.preview' },
  previous: { id: 'app.common.actions.previous' },
  refresh: { id: 'app.common.actions.refresh' },
  remove: { id: 'app.common.actions.remove' },
  removeAll: { id: 'app.common.actions.removeAll' },
  rename: { id: 'app.common.actions.rename' },
  report: { id: 'app.common.actions.report' },
  reset: { id: 'app.common.actions.reset' },
  save: { id: 'app.common.actions.save' },
  select: { id: 'app.common.actions.select' },
  send: { id: 'app.common.actions.send' },
  setNotification: { id: 'app.common.actions.setNotification' },
  suspend: { id: 'app.common.actions.suspend' },
  upload: { id: 'app.common.actions.upload' },
  uploadNewCertificate: { id: 'app.common.actions.uploadNewCertificate' },
  uploadCertificate: { id: 'app.common.actions.uploadCertificate' },
  uploadSimple: { id: 'app.common.actions.uploadSimple' },
  validate: { id: 'app.common.actions.validate' },
  yes: { id: 'app.common.actions.yes' },
  zoomIn: { id: 'app.common.actions.zoomIn' },
  zoomOut: { id: 'app.common.actions.zoomOut' },
  update: { id: 'app.common.actions.update' },
  showAll: { id: 'app.common.table.showAll' },
  hideAll: { id: 'app.common.table.hideAll' },
  columns: { id: 'app.common.table.columns' },
  create: { id: 'app.common.table.create' },
});
